// extracted by mini-css-extract-plugin
module.exports = {"svg":"suitcase-module--svg--1RO_N"};